import { constants as virtualCardConstants } from '@ott/shared-virtual-card-logic';
import { StateByCodeType } from '../types';

const getStateByCode = (code?: string): StateByCodeType => {
  const { CHECK_PAYMENT_CODE } = virtualCardConstants;
  const isMonthLimitReached = code === CHECK_PAYMENT_CODE.MONTH_LIMIT_REACHED;
  const isOperationLimitReached = code === CHECK_PAYMENT_CODE.OPERATION_LIMIT_REACHED;

  return {
    isCardNotReleased: code === CHECK_PAYMENT_CODE.NO_CARD,
    isNotEnoughBalance: code === CHECK_PAYMENT_CODE.NOT_ENOUGH_BALANCE,
    isLimitReached: isMonthLimitReached || isOperationLimitReached,
    isMonthLimitReached,
    isOperationLimitReached,
  };
};

export default getStateByCode;
